var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.settingsLoaded)?_c('Settings',{attrs:{"settings":_vm.settings,"active-tab":_vm.activeTab},on:{"updateSettings":_vm.update}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }